import classNames from "classnames";
import React from "react";

interface Props {
  className?: string;
}

export const HamburgerIcon: React.FC<Props> = ({ className }) => {
  return (
    <svg
      width="48px"
      height="48px"
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
      className={classNames(className, "fill-current text-yellow")}
    >
      <rect y="11" width="32" height="6" />
      <rect y="22" width="32" height="6" />
      <rect width="32" height="6" />
    </svg>
  );
};
